Jelly.Payments.Select_Festival = function(Parameters) {
	// Get this badge	
	var $Festival_Anchor = $("#" + Parameters["Namespace"] + " .Festival_Anchor");

	// Highlight this badge
	$Festival_Anchor.addClass("Selected").parent().addClass("Selected");

	// Select every anchor
 	$("#" + Parameters["Namespace"] + " .Event_Anchor:not(.Selected)").click();
}

Jelly.Payments.Select_Event = function(Parameters) {
	// If Other, if all three, select festival
	var $Event_Anchor = $("#" + Parameters["Namespace"] + " .Event_Anchor[data-id=\"" + Parameters["Event"] + "\"]");

	// Determine if selected
	var Is_Selected = $Event_Anchor.parent().hasClass("Selected");

	// Set selected class
	$Event_Anchor.toggleClass("Selected").parent().toggleClass("Selected");

	// Add/remove input
	if (!Is_Selected) {
		Jelly.Actions.Add_Hidden_Value({
			"Namespace": Parameters["Namespace"],
			"Input_Alias": "Event_" + Parameters["Event"],
			"Value": 1
		});		
	}
	else {
		Jelly.Actions.Add_Hidden_Value({
			"Namespace": Parameters["Namespace"],
			"Input_Alias": "Event_" + Parameters["Event"],
			"Value": 0
		});		
	}

	// Calculate total
	var Event_Total = 0;
	$("#" + Parameters["Namespace"] + " .Event_Anchor").each(function () {
		if ($(this).parent().hasClass("Selected")){
			Event_Total += parseFloat($(this).data("amount"));
		}
	});

	// If all three were selected, highlight festival badge and apply discount
	if (!($("#" + Parameters["Namespace"] + " .Event_Anchor:not(.Selected)")).length) {
		// Apply discount
		Event_Total = parseFloat($("#" + Parameters["Namespace"] + " .Festival_Anchor").data("amount"));

		// Add highlight
		$("#" + Parameters["Namespace"] + " .Festival_Anchor").addClass("Selected").parent().addClass("Selected");
		$("#" + Parameters["Namespace"] + " .Payment").addClass("Highlight");
	}

	// Or remove highlight
	else { 
		$("#" + Parameters["Namespace"] + " .Festival_Anchor").removeClass("Selected").parent().removeClass("Selected");
		$("#" + Parameters["Namespace"] + " .Payment").removeClass("Highlight");
	}

	// If not a whole number, make sure total has two digits
	if (Event_Total % 1) {
	 	Event_Total = Event_Total.toFixed(2);
	}	

	// Update total
	var $Payment_Input = $("#" + Parameters["Namespace"] + " .Payment .Input input");
	$Payment_Input
		.val(Event_Total)
		.change();
};